import React from 'react';
import { MessageSquare, Map, Database } from 'lucide-react';
import SpotlightTour from './SpotlightTour';

const TOUR_STEPS = [
  {
    target: '[data-tour="chat-panel"]',
    title: 'Chat Panel',
    content: <>Ask questions about your data here. The <strong className="text-gray-900 dark:text-white font-semibold">AI agent</strong> can <strong className="text-gray-900 dark:text-white font-semibold">query datasets</strong>, <strong className="text-gray-900 dark:text-white font-semibold">generate charts</strong>, and <strong className="text-gray-900 dark:text-white font-semibold">create map layers</strong>.</>,
    placement: 'right',
    icon: MessageSquare,
  },
  {
    target: '[data-tour="map-panel"]',
    title: 'Map Panel',
    content: <>Visualise <strong className="text-gray-900 dark:text-white font-semibold">spatial data</strong> on an interactive map. Layers are generated from your <strong className="text-gray-900 dark:text-white font-semibold">chat queries</strong> or the <strong className="text-gray-900 dark:text-white font-semibold">layer builder</strong>.</>,
    placement: 'left',
    icon: Map,
  },
  {
    target: '[data-tour="data-panel"]',
    title: 'Data Panel',
    content: <><strong className="text-gray-900 dark:text-white font-semibold">Explore and manage</strong> your <strong className="text-gray-900 dark:text-white font-semibold">datasets</strong> and <strong className="text-gray-900 dark:text-white font-semibold">functions</strong> or import new ones.</>,
    placement: 'top',
    icon: Database,
  },
];

const GuidedTour = ({ run, onFinish }) => (
  <SpotlightTour
    run={run}
    onFinish={onFinish}
    steps={TOUR_STEPS}
    finishLabel="Get Started"
    onComplete={() => localStorage.setItem('manteo_tour_completed', 'true')}
  />
);

export default GuidedTour;
